import { useEffect, useState } from 'react';
import useHttp from '../../../hooks/use-http';
import Modal from '../../UI/Modal/Modal';
import '../Administracija.css';
import { toast } from 'react-hot-toast';
import OpcijeMenijaGridProvider from './OpcijeMenijaGridProvider';
import OAutocomplete from '../../UI/MuiAutocomplete';

const meniConfig = {
  url: 'vracanje_menija_combo',
};
const cvorConfig = {
  url: 'vrati_cvorove_combo',
};
const podcvorConfig = {
  url: 'vrati_podcvorove_combo',
};
const opcijeConfig = {
  url: 'vracanje_opcija_programa_combo',
};
function OpcijeMenija(props) {
  const { data: meniData, sendRequest: meniRequest } = useHttp('');
  const { data: cvorData, sendRequest: cvorRequest } = useHttp('');
  const { data: podcvorData, sendRequest: podcvorRequest } = useHttp('');
  const { data: opcijeData, sendRequest: opcijeReqest } = useHttp('');
  const [status, setStatus] = useState(1);
  const [openDelete, setOpenDelete] = useState(false);
  const [formData, setFormData] = useState({
    id: 0,
    idMenija: 0,
    nazivMenija: '',
    idCvora: 0,
    nazivCvora: '',
    idPodcvora: 0,
    nazivPodcvora: '',
    idOpcijePrograma: 0,
    nazivOpcijePrograma: '',
  });

  useEffect(() => {
    // props.sendRequest(initialConfig);
    // props.handleRefreshData(initialConfig);
    meniRequest(meniConfig);
    cvorRequest(cvorConfig);
    podcvorRequest(podcvorConfig);
    opcijeReqest(opcijeConfig);
  }, []);

  const groupData = (form = formData) => {
    const config = {
      url: status === 1 ? 'unos_opcija_menija' : '',
      status,
      method: 'POST',
      data: {
        id: form ? form.id : 0,
        idMenija: form ? form.idMenija : 0,
        idCvora: form ? form.idCvora : 0,
        idPodcvora: form ? form.idPodcvora : 0,
        idOpcijePrograma: form ? form.idOpcijePrograma : 0,
        vremeProm: new Date(),
        idKorProm: +localStorage.getItem('idKorisnika'),
      },
    };
    props.sendRequest(config);
  };

  useEffect(() => {
    if (props.save === true) {
      groupData();
    }
    props.handleSave(false);
  }, [props.save]);

  useEffect(() => {
    const newFormData = {
      ...formData,
      id: 0,
      // idMenija: 0,
      idCvora: 0,
      idPodcvora: 0,
      idOpcijePrograma: 0,
    };
    setFormData(newFormData);
    setStatus(1);
  }, [props.data]);

  const handleOpenDelete = (id) => {
    setOpenDelete(true);
    const newFormData = {
      ...formData,
      id,
    };
    setFormData(newFormData);
  };

  // funkcija za brisanje opcije
  const handleObrisi = () => {
    const config = {
      url: 'brisanje_opcija_menija',
      status: 3,
      method: 'POST',
      data: {
        id: formData.id,
        vremeProm: new Date(),
        idKorProm: +localStorage.getItem('idKorisnika'),
      },
    };
    props.sendRequest(config);
    setOpenDelete(false);
    const newFormData = {
      ...formData,
      id: 0,
    };
    setFormData(newFormData);
  };

  // odvojena funkcija za promenu menija zbog pozviva apija za vracanje opcija za odabrani meni
  const handleClickMeni = (e) => {
    setFormData((curr) => {
      return { ...curr, nazivMenija: e.vrednost, idMenija: e.id };
    });
    const config = {
      url: 'vrati_opcije_menija_grid',
      method: 'POST',
      data: {
        idMenija: e.id === null ? 0 : e.id,
      },
    };
    props.sendRequest(config);
  };

  const handleClickCvor = (e) => {
    setFormData((curr) => {
      return { ...curr, nazivCvora: e.vrednost, idCvora: e.id };
    });
  };
  const handleClickPodcvor = (e) => {
    setFormData((curr) => {
      return { ...curr, nazivPodcvora: e.vrednost, idPodcvora: e.id };
    });
  };
  const handleClickOpcije = (e) => {
    setFormData((curr) => {
      return {
        ...curr,
        nazivOpcijePrograma: e.vrednost,
        idOpcijePrograma: e.id,
      };
    });
  };

  // eslint-disable-next-line no-unused-expressions
  props.isSuccess && toast.success('Opcija menija uspešno uneta.');

  return (
    <>
      {openDelete && (
        <Modal
          title="Upozorenje!"
          message="Da li ste sigurni da želite da obrišete izabranu stavku?"
          type="warning"
          onClose={() => setOpenDelete(false)}
          onConfirm={handleObrisi}
        />
      )}
      {props.error && (
        <Modal
          title="Greška!"
          message={props.error}
          type="error"
          onClose={props.clearError}
        />
      )}
      <div style={{ display: 'inline-flex', width: '100%' }}>
        <div>
          <OAutocomplete
            label="Meni"
            name="nazivMenija"
            value={formData.nazivMenija}
            data={meniData}
            style={{ width: '250px', cursor: 'pointer' }}
            handleClick={(e) => handleClickMeni(e)}
            handleClear={() => {
              setFormData((curr) => {
                return { ...curr, nazivMenija: '', idMenija: null };
              });
            }}
          />
        </div>
        <div>
          <OAutocomplete
            label="Čvor"
            name="nazivCvora"
            value={formData.nazivCvora}
            data={cvorData}
            handleClick={(e) => handleClickCvor(e)}
            style={{ width: '250px', cursor: 'pointer' }}
            handleClear={() => {
              setFormData((curr) => {
                return { ...curr, nazivCvora: '', idCvora: null };
              });
            }}
          />
        </div>
        <div>
          <OAutocomplete
            label="Podčvor"
            name="nazivPodcvora"
            value={formData.nazivPodcvora}
            data={podcvorData}
            handleClick={(e) => handleClickPodcvor(e)}
            style={{ width: '250px', cursor: 'pointer' }}
            handleClear={() => {
              setFormData((curr) => {
                return { ...curr, nazivPodcvora: '', idPodcvora: null };
              });
            }}
          />
        </div>
        <div>
          <OAutocomplete
            label="Opcija programa"
            name="nazivOpcijePrograma"
            value={formData.nazivOpcijePrograma}
            data={opcijeData}
            handleClick={(e) => handleClickOpcije(e)}
            style={{ width: '250px', cursor: 'pointer' }}
            handleClear={() => {
              setFormData((curr) => {
                return {
                  ...curr,
                  nazivOpcijePrograma: '',
                  idOpcijePrograma: null,
                };
              });
            }}
          />
        </div>
      </div>

      <div style={{ display: 'flex' }}>
        <OpcijeMenijaGridProvider
          data={props.data}
          loading={props.isLoading}
          handleOpenDelete={handleOpenDelete}
        />
        <div style={{ marginLeft: '2rem' }}>
          <h3>Dodavanje opcija u Meni</h3>
          <ol>
            <li>
              <strong>Dodavanje novog čvora:</strong> Bira se meni i čvor iz
              opcija programa (combo-box)
            </li>
            <li>
              <strong>Dodavanje podčvora:</strong> bira se Meni, bira se
              prethodno dodati čvor i podčvor iz opcija Menija
            </li>
            <li>
              <strong>Dodavanje opcije programa:</strong> bira se Meni, bira se
              čvor, bira se podčvor i opcija iz Opcije Programa.
            </li>
          </ol>
        </div>
      </div>
    </>
  );
}

export default OpcijeMenija;
